import React from 'react'
import Index from '../views/dashboard/index'
//import SignIn from '../views/dashboard/Smith/Login/signin';
//import FormWizard from '../views/dashboard/Smith/Masters/supplier-master';

// import { Switch, Route } from 'react-router-dom'
// user
import UserProfile from '../views/dashboard/app/user-profile';
import UserAdd from '../views/dashboard/app/user-add';
import UserList from '../views/dashboard/app/user-list';

// import userProfileEdit from '../views/dashboard/app/user-privacy-setting';
// widget
import Widgetbasic from '../views/dashboard/widget/widgetbasic';
import Widgetcard from '../views/dashboard/widget/widgetcard';
import Widgetchart from '../views/dashboard/widget/widgetchart';
// icon
import Solid from '../views/dashboard/icons/solid';
import Outline from '../views/dashboard/icons/outline';
import DualTone from '../views/dashboard/icons/dual-tone';
// Form
import FormElement from '../views/dashboard/from/form-element';
import FormValidation from '../views/dashboard/from/form-validation';
import FormWizard from '../views/dashboard/from/form-wizard';
import FormDealSmithTransaction from '../views/dashboard/table/MasterDealSmithForm';

//trancation form
import FormTransactionLotIssue from '../views/dashboard/table/TransactionLotIssueForm';
import FormTransactionOrnamentRecepit from '../views/dashboard/table/TransactionOrnamentRecepitForm';
import FormTransactionHOMESALE  from '../views/dashboard/table/TransactionHOMESALEForm';

//D:\smith\src\views\dashboard\table\Master_Deal_Smith_Form
// table
import BootstrapTable from '../views/dashboard/table/bootstrap-table';
import TableData from '../views/dashboard/table/table-data';
import TableDataDealSmith from '../views/dashboard/table/table-data-dealSmith';
import TableDataMasterDepartment from '../views/dashboard/table/table-data-masterDepartment';
import TableDataMasterProduct from '../views/dashboard/table/table-data-masterProduct';
import TableDataMasterCounter from '../views/dashboard/table/table-data-masterCounter';
import TableDataMasterItem from '../views/dashboard/table/table-data-masterItem';
import TableDataMastersubProduct from '../views/dashboard/table/table-data-mastersubProduct';
import TableDataMasterUOM from '../views/dashboard/table/table-data-masterUOM';
import TableDataMasterRateNew from '../views/dashboard/table/table-data-masterRateNew';
import TableDataMasterTag from '../views/dashboard/table/table-data-masterTag';
import TableDataMasterHallMarkRate from '../views/dashboard/table/table-data-masterHallMarkRate';
import TableDataMasterPurchasedDetails from '../views/dashboard/table/table-data-masterPurchasedDetails';
import TableDataMasterWasteTable from '../views/dashboard/table/table-data-masterWasteTable';
import TableDataMasterPurity from '../views/dashboard/table/table-data-masterPurtiy';



//Tansaction Table

import TableDataTransactionLotIssue from '../views/dashboard/table/TableDataTransactionLotIssue';
import TableDataTransactionHOMESALE from '../views/dashboard/table/TableDataTransactionHOMESALE';

// Admin Trnsaction

import TableDataAdminUserManagementDisplay from '../views/dashboard/table/admin/usermanagement/display';
import FormAdminUserManagement from '../views/dashboard/table/admin/usermanagement/entry';
//Smith Transaction
import TableDataTransactionMetalReceipt from '../views/dashboard/table/smith/metalreceipt/list';
import FormTransactionMetalReceipt  from '../views/dashboard/table/smith/metalreceipt/entry';

import TableDataTransactionOrnamentReceipt from '../views/dashboard/table/smith/ornamentreceipt/list';
import FormTransactionOrnamentReceipt  from '../views/dashboard/table/smith/ornamentreceipt/entry';

import TableDataTransactionOrnamentReceipt1 from '../views/dashboard/table/smith/ornamentreceipt/list1';
import FormTransactionOrnamentReceipt1  from '../views/dashboard/table/smith/ornamentreceipt/entry1';


import TableDataTransactionOrnamentIssue from '../views/dashboard/table/smith/ornamentissue/list';
import FormTransactionOrnamentIssue  from '../views/dashboard/table/smith/ornamentissue/entry';


import TableDataTransactionBranchIssue from '../views/dashboard/table/smith/branchissue/list';
import FormTransactionBranchIssue  from '../views/dashboard/table/smith/branchissue/entry';

import TableDataTransactionMetalIssue from '../views/dashboard/table/smith/metalissue/list';
import FormTransactionMetalIssue  from '../views/dashboard/table/smith/metalissue/entry';

import TableDataTransactionCashPayment from '../views/dashboard/table/smith/cashpayment/list';
import FormTransactionCashPayment  from '../views/dashboard/table/smith/cashpayment/entry';

import TableDataTransactionCashReceipt from '../views/dashboard/table/smith/cashreceipt/list';
import FormTransactionCashReceipt  from '../views/dashboard/table/smith/cashreceipt/entry';

//smith report
import TableSmithReportDealderLedgerAll from '../views/dashboard/table/smith/reports/display';
import TableSmithReportAll from '../views/dashboard/table/smith/reports/reportall';
import TableSmithReportOthers from '../views/dashboard/table/smith/reports/reportsothers';

//Plussing Master
import TableDataTransactionMasHallmark from '../views/dashboard/table/plussing/mashallmark/list';
import FormTransactionMasHallmark  from '../views/dashboard/table/plussing/mashallmark/entry';

import TableDataTransactionOtherLotEntry from '../views/dashboard/table/plussing/otherlotentry/list';
import FormTransactionOtherLotEntry  from '../views/dashboard/table/plussing/otherlotentry/entry';

import TableDataTransactionTaggedScreen from '../views/dashboard/table/plussing/taggedscreen/list';
import FormTransactionTaggedScreen  from '../views/dashboard/table/plussing/taggedscreen/entry';
   
import TableDataTransactionNonTaggedScreen from '../views/dashboard/table/plussing/nontaggedscreen/list';
import FormTransactionNonTaggedScreen  from '../views/dashboard/table/plussing/nontaggedscreen/entry';

import TableDataTransactionRepairTaggedScreen from '../views/dashboard/table/plussing/repairtaggedscreen/list';
import FormTransactionRepairTaggedScreen  from '../views/dashboard/table/plussing/repairtaggedscreen/entry';

import TableDataTransactionPlusingRtn from '../views/dashboard/table/plussing/plusingrtn/list';
import FormTransactionPlusingRtn  from '../views/dashboard/table/plussing/plusingrtn/entry';



// sales
    
import TableDataTransactionSalesSalesBill from '../views/dashboard/table/sales/salesbill/list';
import TableDataTransactionSalesRepairDelivery from '../views/dashboard/table/sales/repairdelivery/list';
import TableDataTransactionSalesOrderDelivery from '../views/dashboard/table/sales/orderdelivery/list';
import TableDataTransactionSalesSalesEst from '../views/dashboard/table/sales/salesest/list';
import TableDataTransactionSalesPurchaseOnly from '../views/dashboard/table/sales/purchaseonly/list';
import FormTransactionSalesPurchaseOnly  from '../views/dashboard/table/sales/purchaseonly/entry';
import TableDataTransactionSalesOtherIssue from '../views/dashboard/table/sales/otherissue/list';
import FormTransactionSalesOtherIssue  from '../views/dashboard/table/sales/otherissue/entry';
import TableDataTransactionSalesOrnamentOut from '../views/dashboard/table/sales/ornamentout/list';
import FormTransactionSalesOrnamentOut  from '../views/dashboard/table/sales/ornamentout/entry';
import TableDataTransactionSalesLedgerTypeMaster from '../views/dashboard/table/sales/ledgertypemaster/list';
import FormTransactionSalesLedgerTypeMaster  from '../views/dashboard/table/sales/ledgertypemaster/entry';
import TableDataTransactionSalesReceipt from '../views/dashboard/table/sales/receipt/list';
import FormTransactionSalesReceipt  from '../views/dashboard/table/sales/receipt/entry';
import TableDataTransactionSalesPayment from '../views/dashboard/table/sales/payment/list';
import FormTransactionSalesPayment  from '../views/dashboard/table/sales/payment/entry';

// order and repair
import TableDataTransactionExtrasMas from '../views/dashboard/table/oandr/extrasmas/list';
import FormTransactionExtrasMas  from '../views/dashboard/table/oandr/extrasmas/entry';

import TableDataTransactionOandROrder from '../views/dashboard/table/oandr/order/list';
import FormTransactionOandROrder  from '../views/dashboard/table/oandr/order/entry';
import TableDataTransactionOandRRepair from '../views/dashboard/table/oandr/repair/list';
import FormTransactionOandRRepair  from '../views/dashboard/table/oandr/repair/entry';
import TableDataTransactionOandRSmithPro from '../views/dashboard/table/oandr/smithpro/list';
import FormTransactionOandRSmithPro  from '../views/dashboard/table/oandr/smithpro/entry';
import TableDataTransactionOandRFOrder from '../views/dashboard/table/oandr/forder/list';
import FormTransactionOandRFOrder  from '../views/dashboard/table/oandr/forder/entry';
import TableDataTransactionOandROrderRepay from '../views/dashboard/table/oandr/orderrepay/list';
import FormTransactionOandROrderRepay  from '../views/dashboard/table/oandr/orderrepay/entry';


// Chit
import TableDataChitSchemeMaster from '../views/dashboard/table/chit/schememaster/list';
import FormChitSchemeMaster  from '../views/dashboard/table/chit/schememaster/entry';

import TableDataChitNewScheme from '../views/dashboard/table/chit/newscheme/list';
import FormChitNewScheme  from '../views/dashboard/table/chit/newscheme/entry';

import TableDataChitSchemeRec from '../views/dashboard/table/chit/schemerec/list';
import FormChitSchemeRec  from '../views/dashboard/table/chit/schemerec/entry';


import TableDataChitSettlement from '../views/dashboard/table/chit/settlement/list';
import FormChitSettlement  from '../views/dashboard/table/chit/settlement/entry';


// map
import Vector from '../views/dashboard/maps/vector';
import Google from '../views/dashboard/maps/google';

//extra
// import PrivacyPolicy from '../views/dashboard/extra/privacy-policy';
// import TermsofService from '../views/dashboard/extra/terms-of-service';

//TransitionGroup
// import { TransitionGroup, CSSTransition } from "react-transition-group";
//Special Pages
import Billing from '../views/dashboard/special-pages/billing';
import Kanban from '../views/dashboard/special-pages/kanban';
import Pricing from '../views/dashboard/special-pages/pricing';
import Timeline from '../views/dashboard/special-pages/timeline';
import Calender from '../views/dashboard/special-pages/calender';
import RtlSupport from '../views/dashboard/special-pages/RtlSupport'

//admin
import Admin from '../views/dashboard/admin/admin';
import Default from '../layouts/dashboard/default';

//import SignIn from '../views/dashboard/auth/sign-in';
//import Default from '../views/dashboard/Smith/Login/signin';
//import Default from '../views/dashboard/Smith/Masters/supplier-master';


export const DefaultRouter = [
    {
        path: '/',
        element: <Default />,
        children: [

            {
                path: 'dashboard',
                element: <Index />
            },
            {
                path: 'dashboard/special-pages/billing',
                element: <Billing />
            },
            {
                path: 'dashboard/special-pages/calender',
                element: <Calender />
            },
            {
                path: 'dashboard/special-pages/kanban',
                element: <Kanban />
            },
            {
                path: 'dashboard/special-pages/pricing',
                element: <Pricing />
            },
            {
                path: 'dashboard/special-pages/timeline',
                element: <Timeline />
            },
            {
                path: 'dashboard/special-pages/rtl-support',
                element: <RtlSupport />,
            },
            {
                path: 'dashboard/app/user-profile',
                element: <UserProfile />
            },
            {
                path: 'dashboard/app/user-add',
                element: <UserAdd />
            },
            {
                path: 'dashboard/app/user-list',
                element: <UserList />
            },
            {
                path: 'dashboard/admin/admin',
                element: <Admin />
            },
            
            

            // Widget
            {
                path: 'dashboard/widget/widgetbasic',
                element: <Widgetbasic />
            },
            {
                path: 'dashboard/widget/widgetchart',
                element: <Widgetchart />
            },
            {
                path: 'dashboard/widget/widgetcard',
                element: <Widgetcard />
            },
            // Map
            {
                path: 'dashboard/map/google',
                element: <Google />
            },
            {
                path: 'dashboard/map/vector',
                element: <Vector />
            },
            // Form
            {
                path: 'dashboard/form/form-element',
                element: <FormElement />
            },
            {
                path: 'dashboard/form/form-wizard',
                element: <FormWizard />
            },
            {
                path: 'dashboard/form/form-validation',
                element: <FormValidation />
            },
            {
                path: 'dashboard/table/MasterDealSmithForm',
                element: <FormDealSmithTransaction />
            },
            {
                path: 'dashboard/table/TransactionLotIssueForm',
                element: <FormTransactionLotIssue />
            },           
            
            {
                path: 'dashboard/table/TransactionOrnamentRecepitForm',
                element: <FormTransactionOrnamentRecepit />
            },
            {
                path: 'dashboard/table/smith/metalreceipt/entry',
                element: <FormTransactionMetalReceipt />
            },
            {
                path: 'dashboard/table/smith/ornamentreceipt/entry',
                element: <FormTransactionOrnamentReceipt />
            },
            {
                path: 'dashboard/table/smith/ornamentreceipt/entry1',
                element: <FormTransactionOrnamentReceipt1 />
            },
            {
                path: 'dashboard/table/smith/ornamentissue/entry',
                element: <FormTransactionOrnamentIssue />
            },
            {
                path: 'dashboard/table/TransactionHOMESALEForm',
                element: <FormTransactionHOMESALE />
            },
           
           
// Plussing Master

            {
                path: 'dashboard/table/plussing/mashallmark/entry',
                element: <FormTransactionMasHallmark />
            },
            {
                path: 'dashboard/table/plussing/mashallmark/list',
                element: <TableDataTransactionMasHallmark />
            },

            {
                path: 'dashboard/table/plussing/otherlotentry/entry',
                element: <FormTransactionOtherLotEntry />
            },
            {
                path: 'dashboard/table/plussing/otherlotentry/list',
                element: <TableDataTransactionOtherLotEntry />
            },

            {
                path: 'dashboard/table/plussing/taggedscreen/entry',
                element: <FormTransactionTaggedScreen />
            },
            {
                path: 'dashboard/table/plussing/taggedscreen/list',
                element: <TableDataTransactionTaggedScreen />
            },
            {
                path: 'dashboard/table/plussing/nontaggedscreen/entry',
                element: <FormTransactionNonTaggedScreen />
            },
            {
                path: 'dashboard/table/plussing/nontaggedscreen/list',
                element: <TableDataTransactionNonTaggedScreen />
            },


            {
                path: 'dashboard/table/plussing/repairtaggedscreen/entry',
                element: <FormTransactionRepairTaggedScreen />
            },
            {
                path: 'dashboard/table/plussing/repairtaggedscreen/list',
                element: <TableDataTransactionRepairTaggedScreen />
            },


            {
                path: 'dashboard/table/plussing/plusingrtn/entry',
                element: <FormTransactionPlusingRtn />
            },
            {
                path: 'dashboard/table/plussing/plusingrtn/list',
                element: <TableDataTransactionPlusingRtn />
            },

// SALES


{
    path: 'dashboard/table/sales/salesbill/list',
    element: <TableDataTransactionSalesSalesBill />
},
{
    path: 'dashboard/table/sales/repairdelivery/list',
    element: <TableDataTransactionSalesRepairDelivery />
},
{
    path: 'dashboard/table/sales/orderdelivery/list',
    element: <TableDataTransactionSalesOrderDelivery />
},
{  
    path: 'dashboard/table/sales/salesest/list',
    element: <TableDataTransactionSalesSalesEst />
},
{
    path: 'dashboard/table/sales/purchaseonly/list',
    element: <TableDataTransactionSalesPurchaseOnly />
},
{
    path: 'dashboard/table/sales/purchaseonly/entry',
    element: <FormTransactionSalesPurchaseOnly />
},
{
    path: 'dashboard/table/sales/otherissue/list',
    element: <TableDataTransactionSalesOtherIssue />
},{
    path: 'dashboard/table/sales/otherissue/entry',
    element: <FormTransactionSalesOtherIssue />
},
{
    path: 'dashboard/table/sales/ornamentout/list',
    element: <TableDataTransactionSalesOrnamentOut />
},{
    path: 'dashboard/table/sales/ornamentout/entry',
    element: <FormTransactionSalesOrnamentOut />
},
{
    path: 'dashboard/table/sales/ledgertypemaster/list',
    element: <TableDataTransactionSalesLedgerTypeMaster />
},{
    path: 'dashboard/table/sales/ledgertypemaster/entry',
    element: <FormTransactionSalesLedgerTypeMaster />
},
{
    path: 'dashboard/table/sales/receipt/list',
    element: <TableDataTransactionSalesReceipt />
},{
    path: 'dashboard/table/sales/receipt/entry',
    element: <FormTransactionSalesReceipt />
},
{
    path: 'dashboard/table/sales/payment/list',
    element: <TableDataTransactionSalesPayment />
},{
    path: 'dashboard/table/sales/payment/entry',
    element: <FormTransactionSalesPayment />
},

// Order and Repair
{
    path: 'dashboard/table/oandr/extrasmas/list',
    element: <TableDataTransactionExtrasMas />
},{
    path: 'dashboard/table/oandr/extrasmas/entry',
    element: <FormTransactionExtrasMas />
},
{
    path: 'dashboard/table/oandr/order/list',
    element: <TableDataTransactionOandROrder />
},{
    path: 'dashboard/table/oandr/order/entry',
    element: <FormTransactionOandROrder />
},
{
    path: 'dashboard/table/oandr/repair/list',
    element: <TableDataTransactionOandRRepair />
},{
    path: 'dashboard/table/oandr/repair/entry',
    element: <FormTransactionOandRRepair />
},
{
    path: 'dashboard/table/oandr/smithpro/list',
    element: <TableDataTransactionOandRSmithPro />
},{
    path: 'dashboard/table/oandr/smithpro/entry',
    element: <FormTransactionOandRSmithPro />
},{
    path: 'dashboard/table/oandr/forder/list',
    element: <TableDataTransactionOandRFOrder />
},{
    path: 'dashboard/table/oandr/forder/entry',
    element: <FormTransactionOandRFOrder />
},{
    path: 'dashboard/table/oandr/orderrepay/list',
    element: <TableDataTransactionOandROrderRepay />
},{
    path: 'dashboard/table/oandr/orderrepay/entry',
    element: <FormTransactionOandROrderRepay />
},

            // Table
            {
                path: 'dashboard/table/bootstrap-table',
                element: <BootstrapTable />
            },
            {
                path: 'dashboard/table/table-data',
                element: <TableData />
            },
            {
                path: 'dashboard/table/table-data-dealSmith',
                element: <TableDataDealSmith />
            },
            {
                path: 'dashboard/table/table-data-masterDepartment',
                element: <TableDataMasterDepartment />
            },
            {
                path: 'dashboard/table/table-data-masterProduct',
                element: <TableDataMasterProduct />
            },
            {
                path: 'dashboard/table/table-data-masterCounter',
                element: <TableDataMasterCounter />
            },
            {
                path: 'dashboard/table/table-data-masterItem',
                element: <TableDataMasterItem />
            },
            {
                path: 'dashboard/table/table-data-mastersubProduct',
                element: <TableDataMastersubProduct />
            },
            {
                path: 'dashboard/table/table-data-masterUOM',
                element: <TableDataMasterUOM />
            },
            {
                path: 'dashboard/table/table-data-masterRateNew',
                element: <TableDataMasterRateNew />
            },
            {
                path: 'dashboard/table/table-data-masterTag',
                element: <TableDataMasterTag />
            },
            {
                path: 'dashboard/table/table-data-masterHallMarkRate',
                element: <TableDataMasterHallMarkRate />
            },
            {
                path: 'dashboard/table/table-data-masterPurchasedDetails',
                element: <TableDataMasterPurchasedDetails />
            },
            {
                path: 'dashboard/table/table-data-masterWasteTable',
                element: <TableDataMasterWasteTable />
            },
            {
                path: 'dashboard/table/table-data-masterPurity',
                element: <TableDataMasterPurity />
            },
           
            {
                path: 'dashboard/table/TableDataTransactionLotIssue',
                element: <TableDataTransactionLotIssue />
            },
            {
                path: 'dashboard/table/smith/metalreceipt/list',
                element: <TableDataTransactionMetalReceipt />
            },
            {
                path: 'dashboard/table/smith/ornamentreceipt/list',
                element: <TableDataTransactionOrnamentReceipt />
            },
            {
                path: 'dashboard/table/smith/ornamentreceipt/list1',
                element: <TableDataTransactionOrnamentReceipt1 />
            },
            {
                path: 'dashboard/table/smith/ornamentissue/list',
                element: <TableDataTransactionOrnamentIssue />
            },
            {
                path: 'dashboard/table/TableDataTransactionHOMESALE',
                element: <TableDataTransactionHOMESALE />
            },
           
            {
                path: 'dashboard/table/admin/usermanagement/display',
                element: <TableDataAdminUserManagementDisplay />
            },
            
            {
                path: 'dashboard/table/admin/usermanagement/entry',
                element: <FormAdminUserManagement />
            },
            // Icon
            {
                path: 'dashboard/icon/solid',
                element: <Solid />
            },
            {
                path: 'dashboard/icon/outline',
                element: <Outline />
            },
            {
                path: 'dashboard/icon/dual-tone',
                element: <DualTone />
            },
            {
                path: 'dashboard/table/smith/branchissue/list',
                element: <TableDataTransactionBranchIssue />
            },
            {
                path: 'dashboard/table/smith/branchissue/entry',
                element: <FormTransactionBranchIssue />
            },
            {
                path: 'dashboard/table/smith/metalissue/list',
                element: <TableDataTransactionMetalIssue />
            },
            {
                path: 'dashboard/table/smith/metalissue/entry',
                element: <FormTransactionMetalIssue />
            },
            {
                path: 'dashboard/table/smith/cashpayment/list',
                element: <TableDataTransactionCashPayment />
            },
            {
                path: 'dashboard/table/smith/cashpayment/entry',
                element: <FormTransactionCashPayment />
            },
            {
                path: 'dashboard/table/smith/cashreceipt/list',
                element: <TableDataTransactionCashReceipt />
            },

            {
                path: 'dashboard/table/smith/reports/display',
                element:<TableSmithReportDealderLedgerAll/>
            },
            {
                path: 'dashboard/table/smith/reports/reportall',
                element:<TableSmithReportAll/>
            }
            ,
            {
                path: 'dashboard/table/smith/reports/reportsothers',
                element:<TableSmithReportOthers/>
            },
            {
                path: 'dashboard/table/smith/cashreceipt/entry',
                element: <FormTransactionCashReceipt />
            }, 
            {
                path: 'dashboard/table/chit/schememaster/entry',
                element: <FormChitSchemeMaster />
            },

            {
                path: 'dashboard/table/chit/schememaster/list',
                element: <TableDataChitSchemeMaster />
            }, 
            {
                path: 'dashboard/table/chit/newscheme/entry',
                element: <FormChitNewScheme />
            },

            {
                path: 'dashboard/table/chit/newscheme/list',
                element: <TableDataChitNewScheme />
            },
            {
                path: 'dashboard/table/chit/schemerec/entry',
                element: <FormChitSchemeRec />
            },

            {
                path: 'dashboard/table/chit/schemerec/list',
                element: <TableDataChitSchemeRec />
            },
            {
                path: 'dashboard/table/chit/settlement/entry',
                element: <FormChitSettlement />
            },

            {
                path: 'dashboard/table/chit/settlement/list',
                element: <TableDataChitSettlement />
            },
        ]
    }
]
// const DefaultRouter = () => {
//     return (
//         <TransitionGroup>
//             <CSSTransition classNames="fadein" timeout={300}>
//                 <Switch>
//                     <Route path="/dashboard" exact component={Index} />
//                     {/* user */}
//                     <Route path="/dashboard/app/user-profile"     exact component={UserProfile} />
//                     <Route path="/dashboard/app/user-add"         exact component={UserAdd}/>
//                     <Route path="/dashboard/app/user-list"        exact component={UserList}/>
//                     <Route path="/dashboard/app/user-privacy-setting" exact component={userProfileEdit}/>
//                      {/* widget */}
//                      <Route path="/dashboard/widget/widgetbasic"   exact component={Widgetbasic}/>
//                      <Route path="/dashboard/widget/widgetcard"    exact component={Widgetcard}/>
//                      <Route path="/dashboard/widget/widgetchart"   exact component={Widgetchart}/>
//                      {/* icon */}
//                      <Route path="/dashboard/icon/solid"           exact component={Solid}/>
//                      <Route path="/dashboard/icon/outline"         exact component={Outline}/>
//                      <Route path="/dashboard/icon/dual-tone"       exact component={DualTone}/>
//                      {/* From */}
//                      <Route path="/dashboard/form/form-element"    exact component={FormElement}/>
//                      <Route path="/dashboard/form/form-validation" exact component={FormValidation}/>
//                      <Route path="/dashboard/form/form-wizard"     exact component={FormWizard}/>
//                      {/* table */}
//                      <Route path="/dashboard/table/bootstrap-table" exact component={BootstrapTable}/>
//                      <Route path="/dashboard/table/table-data"      exact component={TableData}/>
//                      {/*special pages */}
//                      <Route path="/dashboard/special-pages/billing" exact component={Billing}/>
//                      <Route path="/dashboard/special-pages/kanban" exact component={Kanban}/>
//                      <Route path="/dashboard/special-pages/pricing" exact component={Pricing}/>
//                      <Route path="/dashboard/special-pages/timeline" exact component={Timeline}/>
//                      <Route path="/dashboard/special-pages/calender" exact component={Calender}/>
//                      {/* map */}
//                      <Route path="/dashboard/map/vector" exact component={Vector}/>
//                      <Route path="/dashboard/map/google" exact component={Google}/>
//                      {/* extra */}
//                      <Route path="/dashboard/extra/privacy-policy" exact component={PrivacyPolicy}/>
//                      <Route path="/dashboard/extra/terms-of-service" exact component={TermsofService}/>
//                      {/*admin*/}
//                      <Route path="/dashboard/admin/admin" exact component={Admin}/>
//                 </Switch>
//             </CSSTransition>
//         </TransitionGroup>
//     )
// }

// export default DefaultRouter
